import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TokenValidationResult } from "@shared-kernel/application/ports/public/public-repository";
import { verifyTokenValidity } from "./verify-token-validity";

const initialState: RetrievalState<TokenValidationResult | null> = { fetching: "idle", data: null };

export const verifyTokenValidityReducer = createReducer<RetrievalState<TokenValidationResult | null>>(initialState, builder => {
  builder.addCase(verifyTokenValidity.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(verifyTokenValidity.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(verifyTokenValidity.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
